export const GITHUB_ORG = 'made-in-spain';

export const GITHUB_OWNER = 'charlite';

export const GITHUB_ORG_URL = `https://github.com/${GITHUB_ORG}`;

export const GITHUB_PROFILE_URL = `https://github.com/${GITHUB_OWNER}`;

/** App Store listing name */
export const APP_NAME = 'Made in SPAIN';

/** Short brand name for compact UI */
export const APP_NAME_SHORT = 'Made in SPAIN';

export const APP_STORE_URL = 'https://apps.apple.com/us/app/made-in-spain/id6812240189';

/** App Store promotional text (170 char max) */
export const APP_STORE_PROMOTIONAL_TEXT =
  'Made in SPAIN — scan product barcodes with your iPhone camera or photo library and see instantly whether a product is from Spain.';

export const SITE_URL = 'https://made-in-spain.pages.dev';

export const SUPPORT_URL = `${SITE_URL}/contact`;
